<template>
  <LibBaseIcon :size="size">
    <path class="" transform="" d="M96 71.973H71.973V96H24V48.027h24.027V24H96zm-30.014 18.04v-18.04h-17.96v-17.96h-18.04v36zm24.028-60.027h-36v36h36z" />
  </LibBaseIcon>
</template>

<script lang="ts">
import Vue from 'vue'
import LibBaseIcon, { props } from './LibBaseIcon.vue'

export default Vue.extend({
  components: {
    LibBaseIcon,
  },
  props,
})
</script>
